import { render } from "./DefPriceOld.vue?vue&type=template&id=710bcab8&scoped=true"
import script from "./DefPriceOld.vue?vue&type=script&lang=js"
export * from "./DefPriceOld.vue?vue&type=script&lang=js"

import "./DefPriceOld.vue?vue&type=style&index=0&id=710bcab8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710bcab8"]])

export default __exports__